import React from "react";
import css from "classnames";
import styles from "../details.module.css";

interface RProps {
  title: string;
  children: React.ReactNode;
}

const Row: React.FC<RProps> = (props: RProps) => (
  <div className={styles.row}>
    <span className={styles.fieldName}>{props.title}</span>
    <span className={css({ [styles.fieldData]: true, [styles.fieldDataEmpty]: !props.children })}>
      {props.children || "Not available"}
    </span>
  </div>
);
export default Row;
